// ADDED: V2 Page Entry Point following Page -> Module pattern
import React from "react";
import { GeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { useMaintenanceSalaryCombinationV2 } from "../../hooks/useMaintenanceSalaryCombinationV2";
import MaintenanceSalaryCombinationV2Module from "../../components/modules/MaintenanceSalaryCombinationV2/MaintenanceSalaryCombinationV2Module";
import { useFilterManager } from "../../hooks/useFilterManager";
import { FEATURES } from "../../../config/features";

const MaintenanceSalaryCombinationV2Page = ({ user, isHideSideMenu }) => {
  const filterManager = useFilterManager(FEATURES.MAINTENANCE_SALARY_FILTERS);
  const hookMethods = useMaintenanceSalaryCombinationV2(filterManager.apiFilterPayload, user);

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Salary Module > "}</span>
                <span className="border-b border-black">{"Maintenance Salary Combinations"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">Maintenance Salary Combinations (Criteria-Based)</h3>
            </div>

            {/* Passing the hook methods to the Module */}
            <MaintenanceSalaryCombinationV2Module
              user={user}
              filterManager={filterManager}
              {...hookMethods}
            />
          </div>
        </div>
      </div>

      <GeneralMessage
        form={hookMethods.showMessage}
        message={hookMethods.message}
        isSuccess={hookMethods.isSuccess}
      />

      <LoadingSpinner loading={hookMethods.loading} />
    </>
  );
};

export default MaintenanceSalaryCombinationV2Page;